module.exports = __webpack_public_path__ + "img/2021_W28_timelineExplainer.4cddbd5f.png";